/* DPYSR Extras: spielt Limit-Zähler und Set-Angebot ab, sobald sie ins Bild kommen. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          play(e.target);
        });
      }, { threshold: 0.35 })
    : null;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }
  function play(el) {
    el.classList.add('is-on');
    each(el.querySelectorAll('[data-odo]'), function (s) {
      s.style.setProperty('--i', s.getAttribute('data-to'));
    });
  }
  function arm(el) {
    if (el.__dpx) return;
    el.__dpx = true;
    if (RM || !io) {
      el.classList.add('is-on');
      return;
    }
    var strips = el.querySelectorAll('[data-odo]');
    var parts = el.querySelectorAll('.lim__fill,.lim__note,.deal__body');
    each(strips, function (s) {
      s.style.transition = 'none';
      s.style.setProperty('--i', s.getAttribute('data-from'));
    });
    each(parts, function (p) {
      p.style.transition = 'none';
    });
    el.classList.add('is-armed');
    void el.offsetWidth;
    each(strips, function (s) {
      s.style.transition = '';
    });
    each(parts, function (p) {
      p.style.transition = '';
    });
    io.observe(el);
  }
  function init(scope) {
    each((scope || document).querySelectorAll('[data-lim],[data-deal]'), arm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
